export default __webpack_public_path__ + "static/media/eddie.659495f9.png";